import { pick } from 'es-toolkit';
import type { FormFunctionality } from '../../../types';

export function getFormFunctionalitySettings<T extends FormFunctionality>(
  settings: T
): FormFunctionality {
  return pick(settings, [
    'autoresponderEI',
    'autoresponderActive',
    'autoresponderReceiver',
    'autoresponderSenderName',
    'autoresponderReplyTo',
    'autoresponderSubject',
    'autoresponderTemplate',
    'integrationGoogleSheets',
    'integrationGoogleSheetsAuth',
    'integrationGoogleSheetsId',
    'integrationMailchimp',
    'integrationMailchimpAuth',
    'mailActive',
    'mailReceivers',
    'mailSenderName',
    'mailSubject',
    'mailTemplate',
    'mailEI',
    'mailCC',
    'mailBCC',
    'mailReplyTo',
    'recaptcha',
    'fields',
    'integrationMailchimpFieldsMap',
    'submitButtonText',
    'submitMessageTitle',
    'submitMessageText',
    'submitAction',
    'submitRedirectURL',
    'submitMessageButton',
    'submitMessageButtonText',
    'integrationSMTP',
    'integrationMailchimpList',
    'integrationZapier',
    'webhooks',
    'integrationSettingsID'
  ]);
}
